/* unplugin-vue-components disabled */import script from "./HuaweiAndroid.vue?vue&type=script&setup=true&lang=ts"
export * from "./HuaweiAndroid.vue?vue&type=script&setup=true&lang=ts"

import "./HuaweiAndroid.vue?vue&type=style&index=0&id=690debf2&scoped=true&lang=less"
import "./HuaweiAndroid.vue?vue&type=style&index=1&id=690debf2&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690debf2"]])

export default __exports__